'use client'

import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useGlobalConfigContext } from '../../global-config'
import { StaticImage } from '../../image'
import { TENANT } from '../../tenant'

import newsletterProductsImage from './images/newsletter_products.png'
import { NewsletterSubscribeAdBenefits } from './NewsletterSubscribeAdBenefits'

export const NewsletterSubscribeAd: FC = () => {
  const globalConfig = useGlobalConfigContext()
  const { tenant } = globalConfig

  return (
    <div className="relative mb-5 mt-14 rounded-2xl bg-light-brand-high tablet:mt-0">
      <div className="flex flex-col items-center tablet:flex-row-reverse tablet:items-end">
        <NewsletterSubscribeAdBenefits />
        <div className="translate-x-12 tablet:translate-x-0">
          <StaticImage
            alt=""
            className="rounded-2xl"
            height={230}
            src={newsletterProductsImage}
            width={320}
          />
        </div>
      </div>
      <div className="absolute -top-12 right-12 tablet:left-44 tablet:top-6">
        <div
          className={clsx(
            'mr-3.5 flex size-[86px] shrink-0 flex-col items-center justify-center rounded-full bg-light-tertiary text-center font-mono font-medium text-dark-primary-max tablet:size-[116px]',
            TENANT.CH === tenant ? 'text-s' : 'text-l',
          )}
        >
          <p className="text-m">
            <FormattedMessage id="newsletter.ad.voucherValue" />
          </p>
          <p className="px-3 text-[10px] leading-[15px]">
            <FormattedMessage id="newsletter.benefits.voucherText" />
          </p>
        </div>
      </div>
    </div>
  )
}
